import { defineStore } from 'pinia'
import { IRegionsPayload, fetchItems } from '@/api/regions'

export const useRegionsStore = defineStore('regions', () => {
  const SearchItems = async (payload: IRegionsPayload) => {
    const response = await fetchItems(payload)
    return response.data
  }
  return { SearchItems }
})
